import React from "react";

import Stack from "@readai/pulse/components/Stack";

import { NotificationCard } from "@app/booking/components/styles";

const NotificationLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Stack padding={1.5} variant="center" maxWidth="100%">
      <NotificationCard>{children}</NotificationCard>
    </Stack>
  );
};

export default NotificationLayout;
